import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/services/auth-guard.service';
import { CustomRouteReuseStrategy } from "./shared/router/custom-route-reuse-strategy";
import { AutoLoginPartialRoutesGuard } from "angular-auth-oidc-client";
import { HAS_PERMISSION_CAN_LOAD_FN } from "@fluxys/security";

export const routes: Routes = [
  { path: 'auth-callback', redirectTo: '' },
  { path: '', redirectTo: 'messages-overview', pathMatch: 'full' },
  {
    path: 'dashboard',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    // todo - change AuthGuard to function based, check fluxys framework HAS_PERMISSION_CAN_LOAD_FN to see example
    canActivate:[AuthGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'messages-overview',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    loadChildren: () => import('./messages/messages-overview/messages-overview.module').then(m => m.MessagesOverviewModule),
  },
  {
    path: 'messages-detail',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    loadChildren: () => import('./messages/messages-detail/messages-detail.module').then(m => m.MessagesDetailModule),
  },
  {
    path: 'partners',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./partners/partners.module').then(m => m.PartnersModule),
  },
  {
    path: 'code-translation',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./code-translation/code-translation.module').then(m => m.CodeTranslationModule),
  },
  {
    path: 'message-settings',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./message-settings/message-settings.module').then(m => m.MessageSettingsModule),
  },
  {
    path: 'communication-profiles',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./communication-profiles/communication-profiles.module').then(m => m.CommunicationProfilesModule),
  },
  {
    path: 'secrets',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./secrets/secrets.module').then(m => m.SecretsModule),
  },
  {
    path: 'agreement-updates',
    canLoad: [AutoLoginPartialRoutesGuard, HAS_PERMISSION_CAN_LOAD_FN],
    canActivate:[AuthGuard],
    loadChildren: () => import('./agreement-update/agreement-update.module').then(m => m.AgreementUpdatesModule),
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
  providers: [AuthGuard, { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }],
})
export class AppRoutingModule {
}
